<ap-dyncomponent
  [hidden]="!(showDynComponent$ | async)"
  [caption]="'Global__Satellite'"
  [groupable]="true"
  [canSearch]="true"
  [canCreate]="false"
  [headerIcon]="'ap-icon-fields'"
  [filterTooltip]="'filterTooltip'"
  [columns]="columns$ | async"
  [items]="items$ | async"
  [loading$]="loading$"
  [pager]="pager$ | async"
  [selectable]="{checkboxOnly: false, mode: 'multiple'}">
</ap-dyncomponent>

<ng-container *ngIf="!(showDynComponent$ | async)">
  <ap-section-header>
    <ap-section-header-grid
      [iconId]="'ap-icon-fields'"
      [caption]="'Global__Satellite'"
      [filterPlaceholder]="'Global_Filter'"
      [filterTooltip]="'filterTooltip'"
      [svg]=""
      [showCanCreateButton]="true"
      [canCreate]="false"
      [canSearch]="true"
    ></ap-section-header-grid>
  </ap-section-header>
  <div [class]="'data-unavailable'">
    <ap-responsive-text [text]="'SatelliteDataOnlyForCurrentCampaignYear' | translate"
    ></ap-responsive-text>
  </div>
</ng-container>
